// if more elements are added then update convertGroupIDBToIGroups method in
// manage-idbdatabase.service
export enum FleetBy {
  EquipmentNumber = 'EQ',
  FleetNumber = 'ID',
  LicensePlate = 'LP',
}
